"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Margin = void 0;
const lib_1 = require("../lib");
exports.Margin = (0, lib_1.createUtility)('margin', ({ margin }) => {
    return margin ? `m--${margin}` : null;
});
//# sourceMappingURL=margin.js.map